import { render, staticRenderFns } from "./TimerSettingPage.vue?vue&type=template&id=8bcf28ec&scoped=true&"
import script from "./TimerSettingPage.vue?vue&type=script&lang=js&"
export * from "./TimerSettingPage.vue?vue&type=script&lang=js&"
import style0 from "./TimerSettingPage.vue?vue&type=style&index=0&id=8bcf28ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcf28ec",
  null
  
)

export default component.exports